import Vue from 'vue'
import Vuex from 'vuex'
import lobby from './modules/lobby';
import shell from './modules/shell';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        lobby,
        shell
    }
})
